export const waitForCompanyID = (): Promise<string | undefined> => {
    return new Promise((resolve) => {
        const interval = setInterval(() => {
            if (typeof (window as any).companyID !== 'undefined') {
                clearInterval(interval);
                resolve((window as any).companyID);
            }
        }, 100); // Check every 100ms
    });
};
